/**
 * Created by jtrav on 4/28/2019.
 */
import React,{ Component } from "react";
import { Link } from "react-router-dom";
import {connect} from "react-redux";
import classnames from 'classnames';
import { getZones} from "../../../actions/actionZones";
import { Row, Col, Table, Card, CardBody, CardHeader, Button, TabContent, TabPane, Nav, NavItem, NavLink} from "reactstrap";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";
import moment from "moment";
import ReactJson from 'react-json-view';
import {getLicenses} from "../../../actions/actionSystemInfo";

const routes = [
    {name: "Home", path:"/userdashboard", isActive: false},
    {name: "Zone", path:"/zones", isActive: false},
    {name: "ViewZone", path:"/viewzone", isActive: true},
];

class ViewZone extends Component{
    constructor(props){
        super(props);
        this.state = {
            currentZone: null,
            auto_scaling: false,
            activeTab: 0
        };
    }

    toggle(tab){
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }
  
    componentDidMount(){
        this.props.getZones();
        this.props.getLicenses()
            .then(() => {
                const {licenses} = this.props;
                for (let i in licenses) {
                    if (licenses[i].features && licenses[i].features.auto_scaling === true) {
                        this.setState({auto_scaling: true})
                    }
                }
            });
    }
      
    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.zones.length > 0){        	
            let currentZone = nextProps.zones.find(zone => zone.zone_id === this.props.match.params.id);
            this.setState({currentZone: currentZone});
        }
    }


    render(){
        const {currentZone} = this.state;
        return (
            <div>  
                <BreadCrumbCompo routes={routes}/>    
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        <Card >
                            <CardHeader>
                                <i className="fa fa-align-justify"></i> <strong>View Deployment Zone</strong>
                                {currentZone ? <Link className="pull-right" to={{ pathname: `/updatezone/${currentZone.zone_id}`}}>
                                    <Button size="sm" color="dark"> Edit Zone </Button> </Link> :" "}
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">
                                        <div>
                                            {currentZone?
                                                <Table bordered>
                                                    <tbody>
                                                        <tr><td>Zone Id</td><td>{currentZone.zone_id}</td></tr>
                                                        <tr><td>Zone Name</td><td>{currentZone.zone_name}</td></tr>
                                                        <tr><td>Managers</td><td>{currentZone.managers.length}</td></tr>
                                                        <tr><td>Agents</td><td>{currentZone.servers.length}</td></tr>
                                                        <tr><td>Kasms</td><td>{currentZone.num_kasms}</td></tr>
                                                        <tr><td>Available Slots</td><td>{currentZone.available_slots}</td></tr>
                                                    </tbody>
                                                </Table> :" "}
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        <Card >
                            <CardHeader>
                                <i className="fa fa-align-justify"></i> <strong>Auto Scaling Settings</strong>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">
                                        <div>
                                            {currentZone?
                                               <React.Fragment>
                                                   {this.state.auto_scaling &&
                                                   <React.Fragment>
                                                       <Table bordered>
                                                           <tbody>
                                                           <tr><td>Auto Scaling Enabled</td><td>{currentZone.auto_scaling_enabled?"True":"False"}</td></tr>
                                                           { currentZone.auto_scaling_enabled ?
                                                               <React.Fragment>
                                                                   <tr><td>Minimum Available Slots</td><td>{currentZone.minimum_available_slots}</td></tr>
                                                                   <tr><td>Agent Cores Override</td><td>{currentZone.agent_cores_override}</td></tr>
                                                                   <tr><td>Agent Memory Override (GB)</td><td>{currentZone.agent_memory_override_gb}</td></tr>
                                                                   <tr><td>Register DNS</td><td>{currentZone.register_dns?"True":"False"}</td></tr>
                                                                   <tr><td>DNS Registration Provider</td><td>{currentZone.dns_registration_provider}</td></tr>
                                                                   <tr><td>Base Domain Name</td><td>{currentZone.base_domain_name}</td></tr>
                                                                   <tr><td>Allow Origin Domain</td><td>{currentZone.allow_origin_domain}</td></tr>
                                                                   <tr><td>Upstream Auth Address</td><td>{currentZone.upstream_auth_address}</td></tr>
                                                                   <tr><td>Proxy Connections</td><td>{currentZone.proxy_connections?"True":"False"}</td></tr>
                                                                   <tr><td>Proxy Hostname</td><td>{currentZone.proxy_hostname}</td></tr>
                                                                   <tr><td>Proxy Path</td><td>{currentZone.proxy_path}</td></tr>
                                                                   <tr><td>Proxy Port</td><td>{currentZone.proxy_port}</td></tr>
                                                                   <tr><td>Nginx Cert</td><td>{currentZone.nginx_cert}</td></tr>
                                                                   <tr><td>Nginx Key</td><td>{currentZone.nginx_key}</td></tr>
                                                               </React.Fragment>:""
                                                           }
                                                           </tbody>
                                                       </Table>
                                                       {currentZone.auto_scaling_enabled &&
                                                           <React.Fragment>
                                                               <Nav tabs>
                                                                   <NavItem>
                                                                       <NavLink
                                                                           className={classnames({active: this.state.activeTab === 0})}
                                                                           onClick={() => {
                                                                               this.toggle(0);
                                                                           }}
                                                                       >
                                                                           AWS
                                                                       </NavLink>
                                                                   </NavItem>
                                                                   <NavItem>
                                                                       <NavLink
                                                                           className={classnames({active: this.state.activeTab === 1})}
                                                                           onClick={() => {
                                                                               this.toggle(1);
                                                                           }}
                                                                       >
                                                                           Digital Ocean
                                                                       </NavLink>
                                                                   </NavItem>
                                                               </Nav>
                                                               <TabContent activeTab={this.state.activeTab}>
                                                                   <TabPane tabId={0}>
                                                                       <Table bordered>
                                                                           <tbody>
                                                                               <tr><td>AWS: Enabled</td><td>{currentZone.aws_enabled?"True":"False"}</td></tr>
                                                                               { currentZone.aws_enabled &&
                                                                                   <React.Fragment>
                                                                                       <tr><td>Region</td><td>{currentZone.aws_region}</td></tr>
                                                                                       <tr><td>Access Key ID</td><td>{currentZone.aws_access_key_id}</td></tr>
                                                                                       <tr><td>Secret Access Key</td><td>{currentZone.aws_secret_access_key}</td></tr>
                                                                                       <tr><td>Max EC2 Nodes</td><td>{currentZone.aws_max_ec2_nodes}</td></tr>
                                                                                       <tr><td>EC2 Agent AMI ID</td><td>{currentZone.ec2_agent_ami_id}</td></tr>
                                                                                       <tr><td>EC2 Agent Instance Type</td><td>{currentZone.ec2_agent_instance_type}</td></tr>
                                                                                       <tr><td>EC2 Agent Key Pair Name</td><td>{currentZone.ec2_agent_key_pair_name}</td></tr>
                                                                                       <tr><td>EC2 Agent Security Group ID</td><td>{currentZone.ec2_agent_security_group_id}</td></tr>
                                                                                       <tr><td>EC2 Agent Subnet ID</td><td>{currentZone.ec2_agent_subnet_id}</td></tr>
                                                                                       <tr><td>EC2 Agent EBS Volume Size (GB)</td><td>{currentZone.ec2_agent_ebs_volume_size_gb}</td></tr>
                                                                                       <tr><td>EC2 Agent EBS Volume Type</td><td>{currentZone.ec2_agent_ebs_volume_type}</td></tr>
                                                                                       <tr><td>EC2 Agent IAM</td><td>{currentZone.ec2_agent_iam}</td></tr>
                                                                                       <tr><td>EC2 Agent Startup Script</td><td><span className="whitespacePre">{currentZone.ec2_agent_startup_script}</span></td></tr>
                                                                                   </React.Fragment>
                                                                               }
                                                                           </tbody>
                                                                       </Table>
                                                                   </TabPane>
                                                                   <TabPane tabId={1}>
                                                                       <Table bordered>
                                                                           <tbody>
                                                                               <tr><td>Digital Ocean: Enabled</td><td>{currentZone.digital_ocean_enabled?"True":"False"}</td></tr>
                                                                               {currentZone.digital_ocean_enabled &&
                                                                                   <React.Fragment>
                                                                                       <tr><td>Max Droplets</td><td>{currentZone.digital_ocean_max_droplets}</td></tr>
                                                                                       <tr><td>Token</td><td>{currentZone.digital_ocean_token}</td></tr>
                                                                                       <tr><td>Region</td><td>{currentZone.digital_ocean_region}</td></tr>
                                                                                       <tr><td>Droplet Image</td><td>{currentZone.digital_ocean_droplet_image}</td></tr>
                                                                                       <tr><td>Droplet Size</td><td>{currentZone.digital_ocean_droplet_size}</td></tr>
                                                                                       <tr><td>Tags</td><td>{currentZone.digital_ocean_tags}</td></tr>
                                                                                       <tr><td>SSH Key Name</td><td>{currentZone.digital_ocean_sshkey_name}</td></tr>
                                                                                       <tr><td>Firewall Name</td><td>{currentZone.digital_ocean_firewall_name}</td></tr>
                                                                                       <tr><td>Startup Script</td><td>{currentZone.digital_ocean_startup_script}</td></tr>
                                                                                   </React.Fragment>
                                                                               }
                                                                           </tbody>
                                                                       </Table>
                                                                   </TabPane>
                                                               </TabContent>
                                                           </React.Fragment>
                                                       }
                                                   </React.Fragment>}
                                               </React.Fragment> :" "}
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        );}
}

ViewZone.propTypes = {
    getZones: Proptypes.func.isRequired,
    zones: Proptypes.array,
    licenses: Proptypes.array,
    match: Proptypes.object,
};

export default connect(state => 
    ({
        zones: state.zones.zones || [],
        licenses: state.system_info.licenses
    }),
dispatch => 
    ({
        getLicenses: () => dispatch(getLicenses()),
        getZones: () => dispatch(getZones()),
    }))(ViewZone);


// WEBPACK FOOTER //
// ./src/views/Zones/ViewZone/ViewZone.js